import { Chip } from 'src/shared/design-system/Chip';
import { DishFirstCard, ImageHeader } from 'src/shared/design-system/DishFirstCard';
import { DynamicImage } from 'src/shared/design-system/DynamicImage';
import styled, { css } from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Border, Colors, Font, Mixins, Spacing } from 'web-common/src/shared/styles';

export const DISH_FIRST_DISH_CARD_IMAGE_WIDTH = 238;
export const DISH_FIRST_DISH_CARD_IMAGE_HEIGHT = 160;
export const MIN_RATINGS_TO_SHOW = 3;

export const FOOD_NAME_LINE_HEIGHT = parseInt(Font.LineHeight.M, 10);

export const CuisineListing = styled.span`
  font-size: ${Font.Size.XS};
  line-height: ${Font.LineHeight.XS};
  font-weight: ${Font.Weight.SEMI_BOLD};
  color: ${Colors.GRAY_DARK_30};

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const Container = styled.div`
  font-family: ${Font.Family.SANS};
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;

  width: 240px;
  height: 368px;

  background: ${Colors.WHITE};

  border: 1px solid ${Colors.GRAY_LITE_30};
  border-radius: ${Border.Radius.M};

  cursor: pointer;
`;

export const FoodImage = styled(DynamicImage)`
  width: 100%;
  border-radius: ${Border.Radius.M} ${Border.Radius.M} 0 0;
`;

export const FoodName = styled.span`
  font-size: ${Font.Size.M};
  line-height: ${FOOD_NAME_LINE_HEIGHT}px;
  font-weight: ${Font.Weight.BOLD};
  color: ${Colors.GRAY_DARK_30};
  margin: ${Spacing.EIGHTH} 0;
  text-overflow: ellipsis;
  ${Mixins.Text.overflow(1)}
`;

export const ShefName = styled.span`
  font-size: ${Font.Size.XS};
  font-weight: ${Font.Weight.MEDIUM};
  color: ${Colors.GRAY_DARK_10};

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const PortionSize = styled.div`
  font-size: ${Font.Size.XS};
  color: ${Colors.GRAY_DARK_10};
  font-weight: ${Font.Weight.MEDIUM};
  align-self: center;
  margin-bottom: ${Spacing.EIGHTH};
  ${Mixins.Text.overflow()}
`;

export const Price = styled.span`
  font-size: ${Font.Size.S};
  color: ${Colors.GRAY_DARK_30};
  font-weight: ${Font.Weight.MEDIUM};
  align-self: center;
`;

export const Description = styled.div`
  color: ${Colors.GRAY_DARK_10};
  font-size: ${Font.Size.S};
  font-weight: ${Font.Weight.MEDIUM};
  margin: ${Spacing.HALF} 0;
  ${Mixins.Text.overflow(3)}
`;

export const DishCard = styled(DishFirstCard)<{ isFluid?: boolean; shortCard?: boolean }>`
  ${ifProp(
    'isFluid',
    css`
      min-height: 400px;
      min-width: 200px;
      height: auto;
      width: 100%;

      & ${FoodName} {
        ${Mixins.Text.overflow(1)}
      }

      & ${ImageHeader} {
        max-height: 100%;
        max-width: 100%;
        min-width: auto;
        height: 0px;
        width: 100%;
        padding-bottom: 66.6%;

        & > span {
          width: 100%;
        }
      }
    `
  )}

  ${ifProp(
    'shortCard',
    css`
      max-height: 320px;
    `
  )}
`;

export const StyledServingSizeChip = styled(Chip)<{ showInline: boolean }>`
  font-size: ${Font.Size.XXS};
  color: ${Colors.GRAY_DARK_30};
  background-color: #f5f5f5;
  font-weight: ${Font.Weight.SEMI_BOLD};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  ${ifProp(
    'showInline',
    css`
      box-shadow: unset;
      margin-top: ${Spacing.QUARTER};
      margin-bottom: ${Spacing.HALF};
    `
  )}
`;

export const NotAvailableFooter = styled.div`
  display: flex;
  width: 100%;
`;

export const NotAvailableFooterText = styled.div<{ color?: string }>`
  margin-left: 8px;
  margin-top: 2px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ color }) => color ?? 'inherit'};
`;
